
export default {
  name: "AboutSection",
  props: ['zone']
}
